import React, { forwardRef } from 'react'

const ChatbotIcon = forwardRef<HTMLImageElement, React.ImgHTMLAttributes<HTMLImageElement>>((props, ref) => {
  return <img ref={ref} src="/img/ai-chatbot-icon.svg" alt="Tech Assistant" {...props} />
})

ChatbotIcon.displayName = 'ChatbotIcon'

export default ChatbotIcon
